import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { CompanyService } from '../services/company.service';
import type { Company } from '../types/company.types';
import { toast } from 'sonner';
import { useAuth } from '@/core/auth/AuthContext';

export function useCompany(companyId?: string) {
  const { profile } = useAuth();
  const queryClient = useQueryClient();
  const activeCompanyId = companyId ?? profile?.company_id ?? '';

  const query = useQuery({
    queryKey: ['company', activeCompanyId],
    queryFn: () => CompanyService.getCompany(activeCompanyId),
    enabled: !!activeCompanyId,
  });

  const updateMutation = useMutation({
    mutationFn: (updates: Partial<Company>) => CompanyService.updateCompany(activeCompanyId, updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['company', activeCompanyId] });
      toast.success('Cập nhật thông tin công ty thành công');
    },
    onError: (error: any) => {
      toast.error('Lỗi khi cập nhật: ' + error.message);
    },
  });

  return {
    company: query.data,
    isLoading: query.isLoading,
    updateCompany: updateMutation.mutate,
    isUpdating: updateMutation.isPending,
  };
}

export function useCompanyAuditLogs(companyId: string) {
  return useQuery({
    queryKey: ['company-audit-logs', companyId],
    queryFn: () => CompanyService.getAuditLogs(companyId),
    enabled: !!companyId,
  });
}
